module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"see_all":"View all reviews"}}')
  delete Component.options._Ctor
}
